function Router(config, renderer) {
  const self = this
  const view = $('#page')

  let previous

  const transitionExclusion = {
    Second: 'Third',
    Third: 'Second'
  }

  let pagesCache = new PageCache(config, renderer);

  let handlers = {
    'loading': route('Loading'),
    'overview': route('Overview'),
    'myoptions': route('MyOptions'),
    'second': route('Second'),
    'cancel-second-pillar-exchange-application': route('CancelSecondPillarExchangeApplication'),
    'suspend': route('Suspend'),
    'exit': route('Exit'),
    'cancel-exit': route('CancelExit'),
    'cancel-suspend': route('CancelSuspend'),
    'joinpia': route('JoinPia'),
    'second-pillar-select': route('SecondPillarSelect'),
    'second-pillar-application': route('SecondPillarApplication'),
    'third-pillar-select': route('ThirdPillarSelect'),
    'third-pillar-payment': route('ThirdPillarPayment'),
    'third-pillar-application': route('ThirdPillarApplication'),
    'suspendsigning': route('SuspendSigning'),
    'exitsigning': route('ExitSigning'),
    'piasigning': route('PiaSigning'),
    'success': route('Success'),
    'thirdpillarsuccess': route('ThirdPillarSuccess'),
    'piasuccess': route('PiaSuccess'),
    'pendingapplications': route('PendingApplications'),
    'monthlyPayment': route('MonthlyPayment'),
    'banklink': route('Banklink'),
    'directContact': route('DirectContact'),
    'to-be-continued': route('to-be-continued'),
    'survey': route('Survey'),
    'contribution-rate-change': route('ContributionRateChange'),
    'contribution-rate-change-preview': route('ContributionRateChangePreview')
  };

  function decodeParam(param) {
    return [param[0], decodeURIComponent(param[1].replace(/\+/g, '%20'))]
  }

  self._decodedParams = function (urlParams) {
    return Object.fromEntries(Object.entries(urlParams).map(decodeParam))
  }

  function route(pageName) {
    return function (rawParams) {
      const params = self._decodedParams(rawParams)
      window.scrollTo(0, 0)
      const pageInstance = pagesCache.page(pageName)
      setDirection(pageName)
      previous = pageName
      let renderArguments = pageInstance.init(params)
      view.html(renderer.render(pageName.toLowerCase(), renderArguments));
      if (pageInstance.done) pageInstance.done(params, renderArguments);
      if (typeof dataLayer === 'object') {
        dataLayer && dataLayer.push({event: 'pageview', page: pageName});
      }
    };
  }

  handlers['to-be-continued'] = function () {
    view.html(renderer.render('to-be-continued', {}))
  }

  const router = Rlite(notFound, handlers)

  function notFound() {
    return '<h1>404 Not found :/</h1>'
  }

  function renderCurrentPage() {
    const hash = location.hash || '#'

    if (!window.session && location.hash) {
      localStorage.setItem('redirect-after-login', location.hash)
    }
    if (window.session || hash === '#survey') {
      router(hash.slice(1))
    }
  }

  function setDirection(page) {
    const body = $('body');
    body.removeAttr('class');
    if (page !== previous) {
      body.addClass(calculateAnimationDirection(page))
    }
    body.addClass('page-' + page.toLowerCase())
  }

  function calculateAnimationDirection(page) {
    const routes = Object.keys(handlers)

    let animationDirection = ''
    if (previous && transitionExclusion[previous] !== page) {
      animationDirection = routes.indexOf(page) < routes.indexOf(previous) ? 'right' : 'left';
    }
    return animationDirection
  }

  document.addEventListener('data-changed', renderCurrentPage);
  window.addEventListener('hashchange', renderCurrentPage);
  renderCurrentPage()
}
